(function () {
  const filterSelector =
    '.boost-pfs-filter-option-item button[role="checkbox"]';

  function syncBoostCheckboxStates(root = document) {
    root.querySelectorAll(filterSelector).forEach((button) => {
      const item = button.closest('.boost-pfs-filter-option-item');
      const isChecked =
        item?.classList.contains('selected') ||
        button.getAttribute('aria-checked') === 'true';

      button.setAttribute(
        'aria-checked',
        isChecked ? 'true' : 'false'
      );

      const visualCheckbox = button.querySelector('.boost-pfs-check-box');

      if (visualCheckbox) {
        visualCheckbox.removeAttribute('role');
        visualCheckbox.removeAttribute('aria-checked');
        visualCheckbox.removeAttribute('tabindex');
        visualCheckbox.setAttribute('aria-hidden', 'true');
      }
    });
  }

  let updateScheduled = false;

  function scheduleUpdate() {
    if (updateScheduled) return;

    updateScheduled = true;

    requestAnimationFrame(() => {
      updateScheduled = false;
      syncBoostCheckboxStates();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleUpdate);

  const observer = new MutationObserver(scheduleUpdate);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });
})();